module.exports = __webpack_public_path__ + "img/product_113.a8787f5.svg";